import { useTranslation } from "react-i18next";

import { FilterBar, FilterDefinition, FilterOption } from "@/components/FilterBar";

import { QUALITIES } from "../../../constants";
import { getLocalisedName, translateOptions } from "../../../utils/i18n";
import { DepositFilterValues } from "../types";

interface FiltersProps {
  commodities: { id: number; name: string }[];
  aggregators: { id: number; name: string }[];
  parsedAdministrativeAreas: {
    id: number;
    name: string;
    correspondingType?: { name: string };
  }[];
  filters: DepositFilterValues;
  onChange: (patch: Partial<DepositFilterValues>) => void;
  onClear: () => void;
}

export const Filters = ({
  commodities,
  aggregators,
  parsedAdministrativeAreas,
  filters,
  onChange,
  onClear,
}: FiltersProps) => {
  const { t } = useTranslation();

  const definitions: FilterDefinition<keyof DepositFilterValues>[] = [
    {
      key: "aggregator_id",
      label: t("filters.aggregator"),
      searchable: true,
      options: (aggregators || []).map(aggregator => ({
        value: aggregator.id.toString(),
        label: aggregator.name,
      })),
    },
    {
      key: "location_id",
      label: t("filters.location"),
      searchable: true,
      options: (parsedAdministrativeAreas || []).map(area => ({
        value: area.id.toString(),
        label: area.correspondingType?.name
          ? `${area.name} (${area.correspondingType.name})`
          : area.name,
      })),
    },
    {
      key: "commodity_id",
      label: t("filters.commodity"),
      searchable: true,
      options: (commodities || []).map(commodity => ({
        value: commodity.id.toString(),
        label: getLocalisedName(commodity),
      })),
    },
    {
      key: "quality",
      label: t("filters.quality"),
      options: translateOptions(QUALITIES, t).map((option: FilterOption) => ({
        value: option.value,
        label: option.label,
      })),
    },
  ];

  return (
    <FilterBar definitions={definitions} values={filters} onChange={onChange} onClear={onClear} />
  );
};
